import PropTypes from 'prop-types';
import React from 'react';
import styles from './InactiveStaffList.css';
import OutletCell from './OutletCell';

class InactiveStaffList extends React.Component {
  render() {
    const { employees, employeeDetail } = this.props;
    return (
      <div className={styles.wrapper}>
        <table className={styles['table-header']}>
          <thead>
            <tr>
              <th>Employee Name</th>
              <th>Role</th>
              <th>Assigned Outlet</th>
              {!employeeDetail && <th>&nbsp;</th>}
            </tr>
          </thead>
        </table>
        <div
          className={`${
            styles['table-content-wrapper']
          } staff-table-content-wrapper`}
        >
          <table className={`${styles['table-content']}`}>
            <tbody>{employees.map(this._renderInactiveEmployeeRow)}</tbody>
          </table>
        </div>
      </div>
    );
  }

  _renderInactiveEmployeeRow = employee => {
    const { outlets, employeeDetail } = this.props;
    let className = '';
    if (employeeDetail && employeeDetail.id === employee.id) {
      className = styles.selected;
    }

    return (
      <tr
        key={employee.id}
        className={`${className}`}
        onClick={() => {
          this.props.onClickRow({ employee });
        }}
      >
        <td>
          {employee.first_name} {employee.last_name}
        </td>
        <td className={styles.role}>{employee.role && employee.role.name}</td>
        <td>
          <OutletCell
            outlets={employee.outlets}
            allOutlet={
              employee.outlets && employee.outlets.length === outlets.length
            }
          />
        </td>
        {!employeeDetail && (
          <td>
            <button
              className={`btn ${styles['btn-reactivate']}`}
              onClick={e => this.props.onClickReactivate(e, employee)}
            >
              Reactivate
            </button>
          </td>
        )}
      </tr>
    );
  };
}

InactiveStaffList.propTypes = {
  employees: PropTypes.array,
  employeeDetail: PropTypes.object,
  onClickRow: PropTypes.func,
  outlets: PropTypes.array,
  onClickReactivate: PropTypes.func,
};
export default InactiveStaffList;
